import { useEffect, useState } from 'react';
import { enhancedSitemapService } from '@/services/enhancedSitemapService';

const Sitemap = () => {
  const [sitemapContent, setSitemapContent] = useState<string>('');

  useEffect(() => {
    // Remove all styling and set document to plain XML mode
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.fontFamily = 'monospace';
    document.body.style.whiteSpace = 'pre';
    document.body.style.fontSize = '12px';
    document.body.style.lineHeight = '1.4';
    document.body.style.color = '#000';
    document.body.style.backgroundColor = '#fff';
    
    // Hide all other elements
    const allElements = document.querySelectorAll('*:not(#root):not(#root *)');
    allElements.forEach(el => {
      if (el !== document.body && el !== document.documentElement) {
        (el as HTMLElement).style.display = 'none';
      }
    });
    
    return () => {
      // Reset styles on cleanup
      document.body.style.cssText = '';
    };
  }, []);

  useEffect(() => {
    const generateSitemap = async () => {
      try {
        const content = await enhancedSitemapService.generateSitemap();
        setSitemapContent(content);
      } catch (error) {
        console.error('Failed to generate sitemap:', error);
        // Fallback sitemap
        setSitemapContent(`<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>https://seniorthrive.com/</loc>
    <lastmod>2025-01-25</lastmod>
    <changefreq>weekly</changefreq>
    <priority>1.0</priority>
  </url>
  <url>
    <loc>https://seniorthrive.com/older-adults</loc>
    <lastmod>2025-01-25</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>https://seniorthrive.com/thrivefamily</loc>
    <lastmod>2025-01-25</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>https://seniorthrive.com/caregivers</loc>
    <lastmod>2025-01-25</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.8</priority>
  </url>
</urlset>`);
      }
    };

    generateSitemap();
  }, []);

  return (
    <pre style={{ 
      margin: 0,
      padding: 0,
      fontFamily: 'monospace',
      fontSize: '12px',
      lineHeight: '1.4',
      whiteSpace: 'pre',
      color: '#000',
      backgroundColor: '#fff',
      border: 'none',
      outline: 'none'
    }}>
      {sitemapContent}
    </pre>
  );
};

export default Sitemap;